import { useState } from 'react';
import { T, Ico, Card, Btn } from '../../../design';

/**
 * 4:5 produkt-thumbnail. Viser `src` hvis givet (lazy-load + broken-image-fallback
 * til placeholderen); ellers den stribede placeholder. Når produkt-API'et leverer
 * en `imageUrl`, vises billedet automatisk — indtil da placeholder.
 */
export function Thumb({ size = 52, label, src }: { size?: number; label?: string; src?: string | null }) {
  const [errored, setErrored] = useState(false);
  const showImg = !!src && !errored;
  return (
    <div style={{ width: size, height: size * 1.25, borderRadius: 10, flexShrink: 0, overflow: 'hidden', border: `1px solid ${T.border}`, background: showImg ? T.surface : `repeating-linear-gradient(135deg, ${T.tertiary} 0 6px, ${T.surface} 6px 12px)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.fg3 }}>
      {showImg
        ? <img src={src ?? undefined} alt="" loading="lazy" onError={() => setErrored(true)} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        : label
          ? <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', transform: 'rotate(-90deg)', whiteSpace: 'nowrap', opacity: 0.7 }}>{label}</span>
          : <Ico.pkg size={Math.round(size * 0.34)} />}
    </div>
  );
}

export function ClaimsError({ onRetry, message }: { onRetry: () => void; message?: string }) {
  return (
    <Card pad={28} style={{ textAlign: 'center', marginTop: 8 }}>
      <div style={{ width: 56, height: 56, borderRadius: 16, background: T.errorBg, color: T.error, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Ico.alert size={26} /></div>
      <div style={{ fontSize: 16, fontWeight: 800, color: T.fg }}>Kunne ikke hente reklamationer</div>
      <div style={{ fontSize: 13, color: T.fg3, marginTop: 6, lineHeight: 1.5 }}>{message || 'Der opstod en fejl. Tjek forbindelsen og prøv igen.'}</div>
      <Btn variant="secondary" size="md" onClick={onRetry} style={{ marginTop: 16 }}>Prøv igen</Btn>
    </Card>
  );
}
